/* University_Form details start */

export const universityWeb_Details_form = {
  universityId: "",
  commonApplicationFee: "",
  degreeOffered: "",
  universityDetails: "",
  googleMapUrl: "",
  neighborhood: "",
  commonTuitionFees: "",
};
export const universityWeb_details_classicEditor_Form = {
  aboutUniversity: "",
  whyText: "",
  extraDetails: "",
};

/* University_Form details end 
type,
  placeHolder,
  Title,
  important,
  handleChange,
  value,
  name, */

export const universityWeb_Details_Input_data = [
  {
    name: "University details",
    key_name: "universityDetails",
    type: "text",
    important: true,
  },
  {
    name: "Common Application fees",
    key_name: "commonApplicationFee",
    type: "text",
    important: true,
  },
  {
    name: "Tuition fees",
    key_name: "commonTuitionFees",
    type: "text",
    important: true,
  },
  {
    name: "Degree offered",
    key_name: "degreeOffered",
    type: "text",
    important: true,
  },
  // { name: "Common duration", key_name: "common_duration" },
  {
    name: "Google map Url",
    key_name: "googleMapUrl",
    type: "text",
    important: true,
  },
  {
    name: "Neighborhood",
    key_name: "neighborhood",
    type: "text",
    important: false,
  },
];

export const universityWeb_Details_ClassicEditor_data = [
  {
    name: "About University",
    key_name: "aboutUniversity",
    type: "text",
    important: true,
  },
  {
    name: "Extra details",
    key_name: "extraDetails",
    type: "text",
    important: true,
  },
  { name: "Why Text", key_name: "whyText", type: "text", important: true },
];

// University Form Validation Start

export const University_Web_Details_Form_Checker = (data) => {
  if (data.universityId === "" || data.universityId === null) {
    return ["University Name Mandatory !"];
  } else if (data.universityDetails === "" || data.universityDetails === null) {
    return ["University Details Mandatory !"];
  } else if (
    data.commonApplicationFee === "" ||
    data.commonApplicationFee === null
  ) {
    return ["Common ApplicationFee Mandatory !"];
  } else if (data.commonTuitionFees === "" || data.commonTuitionFees === null) {
    return ["Common Tuition Fee Mandatory !"];
  } else if (data.degreeOffered === "" || data.degreeOffered === null) {
    return ["Degree Offered mandatory !"];
  } else if (data.extraDetails === "" || data.extraDetails === null) {
    return ["Extra Details Mandatory !"];
  } else if (data.googleMapUrl === "" || data.googleMapUrl === null) {
    return ["Google Url Mandatory !"];
  } else if (data.aboutUniversity === "" || data.aboutUniversity === null) {
    return ["About University Mandatory !"];
  } else if (data.whyText === "" || data.whyText === null) {
    return ["Why Text mandatory !"];
  } else {
    return ["success"];
  }
};

// University Form Validation End

//University Web Details Table

export const University_WebsiteDetails_Table = [
  "Edit/Delete",
  "University Name",
  "Application Fee",
  "Degree Offered",
  "Tuition Fees",
  "Map Url",
  "Neighborhood",
  "University Details",
];
